import Chart from 'chart.js/auto';
import def_day_lines from './graph_utils.js';

export default function graph_pcpn(ser,dates,ff,var_S){
  
  var neige = new Array(ff.length);
  var pluie = new Array(ff.length);
  var verglas = new Array(ff.length);
  var pr = new Array(ff.length);
  var pe = new Array(ff.length);
  
  // Les accumulation ne sont pas monotonnes!!!
  // Je ne suis plus certain de cela. C'etait peut-etre due
  // au probleme de bbox trop grand qui ne donnait pas toujours
  // le meme point de grille pour toutes les heures et toutes
  // les champs.
  var prev_neige=0;
  var prev_pluie=0;
  var prev_verglas=0;
  var prev_pr=0;
  
  var sn_color='rgb(52 , 116 , 235)';
  var rn_color='rgb(40 , 200 , 40 )';
  var fr_color='rgb(200, 50  , 50  )';
  var pe_color='rgb(235, 52  , 201)';
  var pr_color='rgb(0  , 0   , 0)';
  
  if(var_S == "ALL" || var_S == "PE"){
    for(let i=0; i < ff.length; i++){
      neige[i]=ff[i][0];
      //if(neige[i] < prev_neige){
	//neige[i] = prev_neige;
      //}
      //prev_neige=neige[i];	    
      pluie[i]=ff[i][1];
      //if(pluie[i] < prev_pluie){
	//pluie[i] = prev_pluie;
      //}
      //prev_pluie=pluie[i];	    
      verglas[i]=ff[i][2];
      //if(verglas[i] < prev_verglas){
//	verglas[i] = prev_verglas;
      //}
      //prev_verglas=verglas[i];
      pr[i]=ff[i][3];
      //if(pr[i] < prev_pr){
	//pr[i] = prev_pr;
      //}
      //prev_pr=pr[i];
      pe[i] = pr[i] - (neige[i]+pluie[i]+verglas[i]);
      //if(pe[i] < .01){pe[i]=0}
    }
  } else if(var_S == "SN"){
    for(let i=0; i < ff.length; i++){
      neige[i]=ff[i][0];
      //if(neige[i] < prev_neige){
	//neige[i] = prev_neige;
      //}
      //prev_neige=neige[i];
    } 
  } else if(var_S == "RN"){
    for(let i=0; i < ff.length; i++){
      pluie[i]=ff[i][0];
      //if(pluie[i] < prev_pluie){
	//pluie[i] = prev_pluie;
      //}
      //prev_pluie=pluie[i];
    }
  } else if(var_S == "FR"){
    for(let i=0; i < ff.length; i++){
      verglas[i]=ff[i][0];
      //if(verglas[i] < prev_verglas){
	//verglas[i] = prev_verglas;
      //}
      //prev_verglas=verglas[i];
    }
  } else if(var_S == "PR"){
    for(let i=0; i < ff.length; i++){
      pr[i]=ff[i][0];
      //if(pr[i] < prev_pr){
	//pr[i] = prev_pr;
      //}
      //prev_pr=pr[i];
    }
  }
  
  var data;
  
  if(var_S == "ALL"){
    data = {
      labels: dates,
      datasets: [
	{
	  label: 'Neige',
	  data: neige,
	  borderColor: sn_color,
	  lineTension: 0.2
	},
	{
	  label: 'Pluie',
	  data: pluie,
	  borderColor: rn_color,
	},
	{
	  label: 'Verglas',
	  data: verglas,
	  borderColor: fr_color,
	  lineTension: 0.2
	},
	{
	  label: 'Grésil',
	  data: pe,
	  borderColor: pe_color,
	  lineTension: 0.2
	},
	{
	  label: 'Total',
	  data: pr,
	  borderColor: pr_color,
	  lineTension: 0.2
	}
      ]
    }
  } else if(var_S == "SN"){
    data = {
      labels: dates,
      datasets: [
	{
	  label: 'Neige',
	  data: neige,
	  borderColor: sn_color,
	  lineTension: 0.2
	}
      ]
    }
  } else if(var_S == "RN"){
    data = {
      labels: dates,
      datasets: [
	{
	  label: 'Pluie',
	  data: pluie,
	  borderColor: rn_color,
	}
      ]
    }
  } else if(var_S == "FR"){
    data = {
      labels: dates,
      datasets: [
	{
	  label: 'Verglas',
	  data: verglas,
	  borderColor: fr_color,
	  lineTension: 0.2
	}
      ]
    }
  } else if(var_S == "PE"){
    data = {
      labels: dates,
      datasets: [
	{
	  label: 'Grésil',
	  data: pe,
	  borderColor: pe_color,
	  lineTension: 0.2
	}
      ]
    }
  } else if(var_S == "PR"){
    data = {
      labels: dates,
      datasets: [
	{
	  label: 'Total',
	  data: pr,
	  borderColor: pr_color,
	  lineTension: 0.2
	}
      ]
    }
  }
  
  const dt = {
    labels: dates,
    datasets: [{
      label: ser.title,
      data: data,
      tension: 0.1
    }]
  };
  var ymin=Math.min(...ff);
  var ymax=Math.max(...ff);
  var ann=[];
  const pcpn_30_line = {
    type: 'line',
    borderColor: 'red',
    borderWidth: 2,
    scaleID: 'y',
    value: 30
  };
  const pcpn_60_line = {
    type: 'line',
    borderColor: 'red',
    borderWidth: 2,
    scaleID: 'y',
    value: 60
  };
  var tt=30
  if(tt>ymin && tt < ymax){
    ann.push(pcpn_30_line)
  }
  var tt=60
  if(tt>ymin && tt < ymax){
    ann.push(pcpn_60_line)
  }

  def_day_lines(dates,ann);  
  
  const ctx = document.getElementById('id_series_canvas');
  if(ser.chart){
    ser.chart.destroy();
  }
  ser.chart = new Chart(ctx, {
    type: 'line',
    data: data,
    options: {
      maintainAspectRatio: false,
      animations: false,
      responsive: true,
      title: {
	display: true,
	text: 'Chart.js Time Scale'
      },
      scales: {
	y: {
	  title: {
	    display: true,
	    text: 'Accumulation équivalent eau [mm]'
	  },
	  min: 0,
	}
      },
      plugins: {
	annotation: {
	  adjustScaleRange: false,
	  annotations: ann
	},
	zoom: {
	  zoom: {
	    wheel: {
	      enabled: true
	    },
	    pinch: {
	      enabled: true
	    },
	    mode: "x",
	    speed: 100				    
	  },
	  pan: {
	    enabled: true,
	    mode: "x",
	    speed: 100
	  }
	}
      }
    }
  });
}

